import { render, staticRenderFns } from "./AppAnalyticsuk.vue?vue&type=template&id=96fa0164&scoped=true&"
import script from "./AppAnalyticsuk.vue?vue&type=script&lang=js&"
export * from "./AppAnalyticsuk.vue?vue&type=script&lang=js&"
import style0 from "./AppAnalyticsuk.vue?vue&type=style&index=0&id=96fa0164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fa0164",
  null
  
)

export default component.exports